<template>
    <div class="footer">
        <div id="footer-company">
            Laines Schmalwasser © 2020
        </div>
<!--        <div id="footer-social-media">-->
<!--            Social Media-->
<!--        </div>-->
    </div>
</template>

<script>
  export default {
    name: "AppFooter"
  }
</script>

<style scoped>
    .footer {
        padding: 10px;
        margin: 0;
        text-align: center;
        background: #f2f2f2;
        line-height: 20px;
        border-top: 1px solid rgba(4,90,141,0.1);


        height: auto;

        display: flex;
        flex-flow: row wrap;
        -webkit-flex-flow: row wrap;
        justify-content: space-evenly;
    }

    #footer-company {
        order: 2;
    }

    #footer-social-media {
        order: 1;
    }
</style>